import { Alert, Button, Gap, Page } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import { useTemplateEditorDispatch, useTemplateEditorState } from '../../../../context/UseTemplateEditorContext';
import styled from 'styled-components';

const SnapshotSelectorContainer = styled.div`
  height: calc(100vh - 100px);
  padding: 2em;
`;

const StyledTable = styled.table`
  display: block;
  width: 100%;
  min-width: 300px;
  height: 70vh;
  overflow-y: scroll;
  border: 1px solid lightgray;
  border-left: 5px solid #ddd;
  background-color: #fff;
`;

const StyledTableRow = styled.tr`
  border-bottom: 1px dotted lightgray;
`;

const StyledTableHeadRow = styled.th<{ textAlign?: string }>`
  background-color: #ddd;
  text-align: ${({ textAlign }) => textAlign ?? 'center'};
`;

const StyledTableCell = styled.td<{ paddingRight?: string; textAlign?: string }>`
  padding: 3px;
  padding-right: ${({ paddingRight }) => paddingRight ?? '3px'};
  text-align: ${({ textAlign }) => textAlign ?? 'left'};
`;

const StyledFirstColTableCell = styled.th`
  padding: 3px 8px;
  text-align: center;
`;

export const SnapshotSelectorView = () => {
  const { t } = useTranslation('designs');
  const { randomCompilationContexts, randomCompilationContextIndex } = useTemplateEditorState();
  const dispatch = useTemplateEditorDispatch();

  const getHandlePickContext = (index: number) => () => {
    dispatch({
      type: 'SET_RANDOM_COMPILATION_CONTEXT',
      payload: {
        compilationContext: randomCompilationContexts[index],
        index,
      },
    });
  };

  return (
    <Page variation="primary" padding={0}>
      <SnapshotSelectorContainer data-testid="SnapshotSelectorView">
        <h3>{t('designGallery.templateEditor.contextsListView.heading')}</h3>
        {randomCompilationContexts.length > 0 && (
          <>
            <p>{t('designGallery.templateEditor.contextsListView.description')}</p>
            {randomCompilationContextIndex === -1 && (
              <>
                <Alert variation="warning" heading="Data has been edited">
                  {t('designGallery.templateEditor.contextsListView.editedContextMessage')}
                </Alert>
                <Gap bottom={10} />
              </>
            )}
            <StyledTable data-testid="CompilationContextsListTable">
              <tr>
                <StyledTableHeadRow>
                  {t('designGallery.templateEditor.contextsListView.tableHead.index')}
                </StyledTableHeadRow>
                <StyledTableHeadRow textAlign="left">
                  {t('designGallery.templateEditor.contextsListView.tableHead.id')}
                </StyledTableHeadRow>
                <StyledTableHeadRow textAlign="left">
                  {t('designGallery.templateEditor.contextsListView.tableHead.basket')}
                </StyledTableHeadRow>
                <StyledTableHeadRow>&nbsp;</StyledTableHeadRow>
              </tr>
              {randomCompilationContexts.map((item, index) => (
                <StyledTableRow data-testid="ccListRow" key={'cc-' + index}>
                  <StyledFirstColTableCell>{index + 1}</StyledFirstColTableCell>
                  <StyledTableCell paddingRight="15px">{item.snapshotId}</StyledTableCell>
                  <StyledTableCell paddingRight="15px">
                    {item.compilationContext.abandonedBasket?.items.length}&nbsp;&nbsp;
                    {item.compilationContext.abandonedBasket?.items.length === 1
                      ? t('designGallery.templateEditor.contextsListView.basketItemsUnitSingular')
                      : t('designGallery.templateEditor.contextsListView.basketItemsUnitPlural')}
                  </StyledTableCell>
                  <StyledTableCell textAlign="center">
                    {randomCompilationContextIndex !== index && (
                      <Button
                        variation="secondary"
                        onClick={getHandlePickContext(index)}
                        data-testid="ccListItemActionBtn"
                      >
                        {t('designGallery.templateEditor.contextsListView.previewButtonLabel')}
                      </Button>
                    )}
                    {randomCompilationContextIndex === index && (
                      <Button variation="secondary" disabled={true} data-testid="ccListItemActionBtn">
                        {t('designGallery.templateEditor.contextsListView.currentPreviewButtonLabel')}
                      </Button>
                    )}
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </StyledTable>
          </>
        )}
      </SnapshotSelectorContainer>
    </Page>
  );
};
